export default __webpack_public_path__ + "static/media/noSignature-icon.146a10f7.png";